<template>
  <div class="">
    <v-row>
      <v-col md="6" sm="12" v-if="history.length <= 0">
        <v-alert border="right" prominent type="info" color="#e16979" dark>
          There is no history of todos'
        </v-alert>
      </v-col>
      <v-col md="12" sm="12">
        <!-- <v-simple-table v-if="history.length > 0">
          <thead>
            <tr>
              <th class="text-left">Title</th>
              <th class="text-left">Link</th>
              <th class="text-left">Child</th>
              <th class="text-left">User</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(task, index) in history" :key="task.id">
              <td>{{ task.title }}</td>
              <td><a :href=task.link target="_blank">{{ task.link }}</a></td>
              <td>{{ task.children.name }}</td>
              <td class="text-capitalize">
                {{ task.user.first_name }} {{ task.user.last_name }}
              </td>
              <td>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#06bab1"
                      class="my-2 mx-2"
                      @click="restore(task.id, index)"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-refresh</v-icon
                    >
                  </template>
                  <span>Restore to board</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#e16979"
                      class="my-2 mx-2"
                      @click="deleteTask(task.id, index)"
                      v-bind="attrs"
                      v-on="on"
                      >mdi-delete-empty</v-icon
                    >
                  </template>
                  <span>Delete from DB</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </v-simple-table> -->
        <v-data-table-header>Hello there</v-data-table-header>
        
        <v-data-table
          :headers="headers"
          :items="history"
          :items-per-page="15"
          group-by="user.last_name"
          show-group-by
          :loading ="loading"
          loading-text="Loading... Please wait"
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";

export default {
  metaInfo: {
    title: "INCAB > Archive",
  },
  mounted() {
    axios.get("/api/v1/deleted_tasks/").then((response) => {
      this.history = response.data;
      this.loading = false
      
    })
  },
  methods: {
    restore(id, index) {
      axios
        .patch(`/api/v1/tasks/${id}/`, { status: "", state: 4 })
        .then((response) => {
          this.history.splice(index, 1);
        });
    },
    deleteTask(id, index) {
      axios.delete(`/api/v1/tasks/${id}/`).then((response) => {
        this.history.splice(index, 1);
      });
    },
  },

  data() {
    return {
      loading:true,
      history: [],
      headers:[
        { text: 'Id', value: 'id', sortable: false, align: 'start',groupable: false },
        { text: 'Title', value: 'title', sortable: false, align: 'start',groupable: false  },
        { text: 'User', value: 'user.last_name', align: 'start'  },
        { text: 'Link', value: 'link', sortable: false, align: 'start',groupable: false  },
        { text: 'Score', value: 'score', align: 'start' },
        { text: 'Duration(hours)', value: 'total_duration', align: 'start' },
      ]
    };
  },
};
</script>
